import { FilterAltOff } from '@mui/icons-material'
import { Stack, Button, Tooltip, IconButton } from '@mui/material'
import React from 'react'
import { Control } from 'react-hook-form'
import { ControlledAutocomplete } from 'src/components/forms/ControlledAutocomplete'
import { usePaisLogo } from 'src/hooks/usePaisLogo'
import { HttpSystems } from 'src/http/workflow/httpSystems'
import { GroupFilterDTOFields } from 'src/types/group/groupData'

interface CountryFilterProps {
    control: Control<any>,
    name: string,
    onReset: () => void,
    onSearch: () => void,
}

const CountryFilter = ({control, name, onReset, onSearch}: CountryFilterProps) => {
    const {getPaisLogoPorCodigo, paisLogos, loading} = usePaisLogo()

    return (
        <Stack
            direction='row'
            spacing={2}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                p: 2
            }}
        >
            <ControlledAutocomplete
                control={control}
                name={name}
                valueField='id'
                loadOptions={() => Promise.resolve(loading ? [] : paisLogos)}
                multiple
            />
            <Button type='submit' onClick={onSearch}>
                Buscar
            </Button>
            <Tooltip title='Limpiar filtro'>
                <IconButton
                    onClick={onReset}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </Stack>
    )
}

export default CountryFilter
